import type { CourtRetentionSettings } from "./RetentionSetting.types";

export const DEFAULT_COURT_SETTINGS: CourtRetentionSettings[] = [
  {
    _id: "1",
    courtType: "District Court",
    retentionDays: 0,
    retentionTimeUnit: "",
    description: "",
    isActive: true,
    lastUpdated: "",
    priority: 1,
  },
  {
    _id: "2",
    courtType: "High Court",
    retentionDays: 0,
    retentionTimeUnit: "",
    description: "",
    isActive: true,
    lastUpdated: "",
    priority: 2,
  },
];
